import React, { useEffect, useState, useContext } from 'react';
import LoadingTable from '../LoadingTable';
import Axios from "axios";
import "../../components/style.css";
import { thai_date, getFontSize, calculateSummaryAndPercentages, prepareSeriesForChart, checkGroupsUser, getlocalStorage, calculateSumsByUnit, getOverallSummary, calculateSumsByAirWorker } from '../../function/functionALL';
import "../../components/style.css";
import { Chart, registerables } from 'chart.js';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
import "../../components/style.css";
import ApexCharts from 'react-apexcharts';
import { YearContext } from '../usecontext/YearContext';
import Swal from "sweetalert2";
import { Bar ,Pie} from 'react-chartjs-2';

Chart.register(...registerables, MatrixController, MatrixElement);
const ReportChartComponent = ({ showChartReport, unitname, all_round }) => {
    const [loading, setLoading] = useState(true);
    const { Token, DataToken_ } = getlocalStorage();
    const role = checkGroupsUser(DataToken_.groups)
    const role_openRole = role?.openRole
    const [chartReady, setChartReady] = useState(false);
    const [ReportData1, setReportData1] = useState(0);
    const [ReportData2, setReportData2] = useState(0);
    const [Pass_All_StationData, setPass_All_StationData] = useState({
        round1: {},
        round2: {}
    });
    const [Heatmap1, setHeatmap1] = useState([]);
    const [Heatmap2, setHeatmap2] = useState([]);
    const [percentageData, setPercentageData] = useState([]);
    const DateTime = new Date()
    const { yearcurrent } = useContext(YearContext);

    useEffect(() => {

        if (unitname === undefined) {
            GetReport1();
            GetReport2();
            fetchDataAllstation1();
            fetchDataAllstation2();
        } else {
            GetReport1unit();
            GetReport2unit();
            fetchDataAllstation1unit();
            fetchDataAllstation2unit();
        }



    }, [yearcurrent, unitname]);

    // useEffect(() => {

    //     if (
    //         ReportData1 && Object.keys(ReportData1).length > 0 &&
    //         ReportData2 && Object.keys(ReportData2).length > 0 &&
    //         Pass_All_StationData && Object.keys(Pass_All_StationData).length > 0 
    //         // && Heatmap1.length > 0 && Heatmap2.length > 0
    //     ) {
    //         setChartReady(true);
    //     }
    // }, [ReportData1, ReportData2, Pass_All_StationData]);

    useEffect(() => {
        if (Heatmap1.length > 0) {

            setChartReady(true);
        }
    }, [Heatmap1]);

        useEffect(() => {
        if (Heatmap2.length > 0) {

            setChartReady(true);
        }
    }, [Heatmap2]);

    const GetReport1 = async () => {
        try {


            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `report_summary/?budget_year=${yearcurrent}&round=1`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            // console.log('allDataReport1:',allData)
            const groupedData = calculateSumsByUnit(allData); // จัดกลุ่มข้อมูลตาม unit
            // console.log('Grouped Data by Unit with Sums ครั้งที่ 1:', groupedData);
            const overallSummary = getOverallSummary(groupedData);   // สรุปข้อมูลรวมทุก unit
            // console.log('Overall Summary ครั้งที่ 1:', overallSummary);
            setReportData1(overallSummary)
            const totalsNumTest3StationsByAirWorker = calculateSumsByAirWorker(allData); //คำนวณทั้งหมด
            setPass_All_StationData(prevData => ({
                ...prevData,
                round1: {
                    totalsNumTest3StationsByAirWorker,
                }
            }));
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);
            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetReport2 = async () => {
        try {


            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `report_summary/?budget_year=${yearcurrent}&round=2`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            // console.log('allDataReport2:',allData)

            const groupedData = calculateSumsByUnit(allData); // จัดกลุ่มข้อมูลตาม unit
            // console.log('Grouped Data by Unit with Sums ครั้งที่ 2:', groupedData);
            const overallSummary = getOverallSummary(groupedData);   // สรุปข้อมูลรวมทุก unit
            // console.log('Overall Summary ครั้งที่ 2:', overallSummary);
            setReportData2(overallSummary)
            const totalsNumTest3StationsByAirWorker = calculateSumsByAirWorker(allData); //คำนวณทั้งหมด
            setPass_All_StationData(prevData => ({
                ...prevData,
                round2: {
                    totalsNumTest3StationsByAirWorker,
                }
            }));
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);
            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetReport1unit = async () => {
        try {


            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `report_summary/?budget_year=${yearcurrent}&round=1`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data.filter(item => item.unit === unitname);
            // console.log(allData)
            const groupedData = calculateSumsByUnit(allData); // จัดกลุ่มข้อมูลตาม unit
            // console.log('Grouped ครั้งที่ 1:', groupedData);
            const overallSummary = getOverallSummary(groupedData);   // สรุปข้อมูลรวมทุก unit
            // console.log('Overall Summary ครั้งที่ 1:', overallSummary);
            setReportData1(overallSummary)
            const totalsNumTest3StationsByAirWorker = calculateSumsByAirWorker(allData); //คำนวณทั้งหมด
            setPass_All_StationData(prevData => ({
                ...prevData,
                round1: {
                    totalsNumTest3StationsByAirWorker,
                }
            }));
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);
            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };
    const GetReport2unit = async () => {
        try {


            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `report_summary/?budget_year=${yearcurrent}&round=2`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            // console.log(response)
            let allData = response.data.filter(item => item.unit === unitname);
            const groupedData = calculateSumsByUnit(allData); // จัดกลุ่มข้อมูลตาม unit
            // console.log('Grouped ครั้งที่ 2:', groupedData);
            const overallSummary = getOverallSummary(groupedData);   // สรุปข้อมูลรวมทุก unit
            // console.log('Overall Summary ครั้งที่ 1:', overallSummary);
            setReportData2(overallSummary)
            const totalsNumTest3StationsByAirWorker = calculateSumsByAirWorker(allData); //คำนวณทั้งหมด
            setPass_All_StationData(prevData => ({
                ...prevData,
                round2: {
                    totalsNumTest3StationsByAirWorker,
                }
            }));
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);
            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };


    const num_unit1 = ReportData1.num_unit || 0;
    const percentageNotTested1 = ReportData1.percentage_not_tested || 0;
    const percentageTested1 = ReportData1.percentage_tested || 0;
    const numNotTested1 = ReportData1.num_not_tested || 0;
    const numTested1 = ReportData1.num_tested || 0;
    const numNoPass1 = ReportData1.percentage_num_no_pass || 0;
    const numPass1 = ReportData1.percentage_num_pass || 0;
    const num_pass_all_score1 = ReportData1.num_pass_all_score || 0;
    const num_no_pass1 = ReportData1.num_no_pass || 0;

    const num_unit2 = ReportData2.num_unit || 0;
    const percentageNotTested2 = ReportData2.percentage_not_tested || 0;
    const percentageTested2 = ReportData2.percentage_tested || 0;
    const numNotTested2 = ReportData2.num_not_tested || 0;
    const numTested2 = ReportData2.num_tested || 0;
    const numNoPass2 = ReportData2.percentage_num_no_pass || 0;
    const numPass2 = ReportData2.percentage_num_pass || 0;
    const num_pass_all_score2 = ReportData2.num_pass_all_score || 0;
    const num_no_pass2 = ReportData2.num_no_pass || 0;

    const round1Ground = Pass_All_StationData?.round1?.totalsNumTest3StationsByAirWorker?.['ผู้ทำการภาคพื้น']?.percentagePass || 0;
    const round1Air = Pass_All_StationData?.round1?.totalsNumTest3StationsByAirWorker?.['ผู้ทำการในอากาศ']?.percentagePass || 0;
    const round2Ground = Pass_All_StationData?.round2?.totalsNumTest3StationsByAirWorker?.['ผู้ทำการภาคพื้น']?.percentagePass || 0;
    const round2Air = Pass_All_StationData?.round2?.totalsNumTest3StationsByAirWorker?.['ผู้ทำการในอากาศ']?.percentagePass || 0;

    const fetchDataAllstation1 = async () => {
        try {
            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_station/?year=${yearcurrent}&round=1`

                , {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });

            const allData = response.data;
            // console.log(allData);
            const allTesterStation = prepareSeriesForChart(allData);
            // console.log('allTesterStation', allTesterStation)      
            const updatedData = calculateSummaryAndPercentages(allTesterStation);
            // console.log('updatedData', updatedData)
            setHeatmap1(updatedData);
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);
            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const fetchDataAllstation2 = async () => {
        try {
            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_station/?year=${yearcurrent}&round=2`

                , {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });

            const allData = response.data;
            // console.log(allData);
            const allTesterStation = prepareSeriesForChart(allData);
            // console.log('allTesterStation', allTesterStation)      
            const updatedData = calculateSummaryAndPercentages(allTesterStation);
            // console.log('updatedData', updatedData)
            setHeatmap2(updatedData);
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });

        }
    };


    const fetchDataAllstation1unit = async () => {
        try {
            setLoading(true)
            const selectedRound = all_round.find((roundData) => roundData.round === 1);
            if (selectedRound === undefined) {
                setHeatmap1([]);
            } else {
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_station/?test_round=${selectedRound.id}`

                , {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });

            const allData = response.data;
            // console.log('หน่วย ครั้งที่ 1',allData);
            const allTesterStation = prepareSeriesForChart(allData);
            // console.log('allTesterStation', allTesterStation)      
            const updatedData = calculateSummaryAndPercentages(allTesterStation);
            // console.log('updatedData', updatedData)
            setHeatmap1(updatedData);
            }
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });

        }
    };
    const fetchDataAllstation2unit = async () => {
        try {
            setLoading(true)
            const selectedRound = all_round.find((roundData) => roundData.round ===2 );
            if (selectedRound === undefined) {
                setHeatmap2([]);
            } else {
            // const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_station/`
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_station/?test_round=${selectedRound.id}`
                //  const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_station/?year=2024`
                //  const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_station/?year=2024&round=1`
                , {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });

            const allData = response.data;
            // console.log('หน่วย ครั้งที่ 2',allData);
            const allTesterStation = prepareSeriesForChart(allData);
            // console.log('allTesterStation', allTesterStation)      
            const updatedData = calculateSummaryAndPercentages(allTesterStation);
            // console.log('updatedData', updatedData)
            setHeatmap2(updatedData);
            }
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });

        }
    };

    const getHeatmapDataOrDefault = (heatmap) => {
        if (heatmap.length === 0) {
            return [{ station: '-', series: Array(11).fill({ score: 0, percentage: 0, category: '-' }) }];
        }
        return heatmap;
    };
    const extractData = (heatmap, key) =>
        getHeatmapDataOrDefault(heatmap).map(station => ({
            name: station.station,
            data: station.series.map(s => s[key] || 0),
        }));
        
    // const extractData = (heatmap, key) =>
    //     heatmap.map(station => ({
    //         name: station.station,
    //         data: station.series.map(s => s[key]),
    //     }));

    const score1 = extractData(Heatmap1, 'score');
    const percentage1 = extractData(Heatmap1, 'percentage');
    const score2 = extractData(Heatmap2, 'score');
    const percentage2 = extractData(Heatmap2, 'percentage');

    const getOptions = (title, heatmapData, formatter, categories) => ({
        chart: {
            type: 'heatmap',
            dropShadow: { enabled: false },
            toolbar: { show: false },
        },
        title: {
            text: title,
            align: 'center',
            style: { fontSize: '12px' },
        },
        xaxis: {
            categories: heatmapData[0].series.map(s => s.category),
            labels: { style: { fontSize: getFontSize() } },
        },
        yaxis: {
            title: { text: 'Station' },
            categories: categories,
            labels: { style: { fontSize: getFontSize() } },
        },
        colors: ['rgb(0, 0, 192,0.2)', 'rgb(0, 0, 192,0.4)', 'rgb(0, 0, 192,0.6)', 'rgb(0, 0, 192,0.8)', 'rgb(0, 0, 192,1)'],
        dataLabels: {
            enabled: true,
            formatter,
            style: { colors: ['#000000'], fontSize: getFontSize() },
        },
    });
    const charts = [
        { 
            title: 'Heat Map ครั้งที่ 1', 
            series: score1, 
            data: getHeatmapDataOrDefault(Heatmap1), 
             formatter: val => val > 0 ? (val > 1000 ? val.toLocaleString() : val) : '-',
            categories: getHeatmapDataOrDefault(Heatmap1).map(station => station.station) 
        },
        { 
            title: 'Percentage Heat Map ครั้งที่ 1', 
            series: percentage1, 
            data: getHeatmapDataOrDefault(Heatmap1), 
            formatter: val => val > 0 ? `${val.toFixed(1)}%` : '-', 
            categories: Object.keys(percentageData) 
        },
        { 
            title: 'Heat Map ครั้งที่ 2', 
            series: score2, 
            data: getHeatmapDataOrDefault(Heatmap2), 
            formatter: val => val > 0 ? (val > 1000 ? val.toLocaleString() : val) : '-', 
            categories: getHeatmapDataOrDefault(Heatmap2).map(station => station.station) 
        },
        { 
            title: 'Percentage Heat Map ครั้งที่ 2', 
            series: percentage2, 
            data: getHeatmapDataOrDefault(Heatmap2), 
            formatter: val => val > 0 ? `${val.toFixed(1)}%` : '-',  
            categories: Object.keys(percentageData) 
        },
    ];
    // const charts = [
    //     { title: 'Heat Map ครั้งที่ 1', series:  score1, data: Heatmap1, formatter: val => val > 0 ? (val > 1000 ? val.toLocaleString() : val) : '-', categories: Heatmap1.map(station => station.station) },
    //     { title: 'Percentage Heat Map ครั้งที่ 1', series: percentage1, data: Heatmap1, formatter: val => val > 0 ? `${val.toFixed(1)}%` : '-', categories: Object.keys(percentageData) },
    //     { title: 'Heat Map ครั้งที่ 2', series: score2, data: Heatmap2, formatter: val => val > 0 ? (val > 1000 ? val.toLocaleString() : val) : '-', categories: Heatmap2.map(station => station.station) },
    //     { title: 'Percentage Heat Map ครั้งที่ 2', series: percentage2, data: Heatmap2, formatter: val => val > 0 ? `${val.toFixed(1)}%` : '-', categories: Object.keys(percentageData) },
    // ];



    // const options_score1 = {
    //     chart: {
    //         type: 'heatmap',

    //         dropShadow: {
    //             enabled: false,
    //         },
    //         toolbar: {
    //             show: false,
    //         },
    //     },
    //     title: {
    //         text: 'Heat Map ครั้งที่ 1',
    //         align: 'center',
    //         style: {
    //             fontSize: '12px',
    //         },
    //     },
    //     xaxis: {
    //         categories: Heatmap1[0]?.series.map(s => s.category),
    //         labels: {
    //             style: {
    //                 fontSize: getFontSize(),
    //             },
    //         },
    //     },
    //     yaxis: {
    //         title: {
    //             text: 'Station',
    //         },
    //         categories: Heatmap1.map(station => station.station),
    //         labels: {
    //             style: {
    //                 fontSize: getFontSize(),
    //             },
    //         },
    //     },
    //     colors: ['rgb(0, 0, 192,0.2)', 'rgb(0, 0, 192,0.4)', 'rgb(0, 0, 192,0.6)', 'rgb(0, 0, 192,0.8)', 'rgb(0, 0, 192,1)'],
    //     dataLabels: {
    //         enabled: true,
    //         formatter: function (val) {
    //             return val > 0 ? (val > 1000 ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : val) : '-';
    //         },
    //         style: {
    //             colors: ['#000000'],
    //             fontSize: getFontSize(),
    //         },
    //     },
    // };

    // const options_percentage1 = {
    //     chart: {
    //         type: 'heatmap',
    //         dropShadow: {
    //             enabled: false,
    //         },
    //         toolbar: {
    //             show: false,
    //         },
    //     },
    //     title: {
    //         text: 'Percentage Heat Map ครั้งที่ 1',
    //         align: 'center',
    //         style: {
    //             fontSize: '12px',

    //         },
    //     },
    //     xaxis: {
    //         categories: Heatmap1[0]?.series.map(s => s.category),
    //         labels: {
    //             style: {
    //                 fontSize: getFontSize(),
    //             },
    //         },
    //     },
    //     yaxis: {
    //         title: {
    //             text: 'Station',
    //         },

    //         categories: Object.keys(percentageData),
    //         labels: {
    //             style: {
    //                 fontSize: getFontSize(),
    //             },
    //         },
    //     },
    //     colors: ['rgb(0, 0, 192,0.2)', 'rgb(0, 0, 192,0.4)', 'rgb(0, 0, 192,0.6)', 'rgb(0, 0, 192,0.8)', 'rgb(0, 0, 192,1)'],
    //     dataLabels: {
    //         enabled: true,
    //         formatter: function (val) {
    //             return val > 0 ? `${val.toFixed(1)}%` : '-';
    //         },
    //         style: {
    //             colors: ['#000000'],
    //             fontSize: getFontSize(),
    //         },
    //     },
    //     series: Object.keys(percentageData).map(exercise => ({
    //         name: exercise,
    //         data: Object.keys(percentageData[exercise]).map(range => parseFloat(percentageData[exercise][range])),
    //     })),
    // };
    // const options_score2 = {
    //     chart: {
    //         type: 'heatmap',

    //         dropShadow: {
    //             enabled: false,
    //         },
    //         toolbar: {
    //             show: false,
    //         },
    //     },
    //     title: {
    //         text: 'Heat Map ครั้งที่ 2',
    //         align: 'center',
    //         style: {
    //             fontSize: '12px',
    //         },
    //     },
    //     xaxis: {
    //         categories: Heatmap2[0]?.series.map(s => s.category),
    //         labels: {
    //             style: {
    //                 fontSize: getFontSize(),
    //             },
    //         },
    //     },
    //     yaxis: {
    //         title: {
    //             text: 'Station',
    //         },
    //         categories: Heatmap2.map(station => station.station),
    //         labels: {
    //             style: {
    //                 fontSize: getFontSize(),
    //             },
    //         },
    //     },
    //     colors: ['rgb(0, 0, 192,0.2)', 'rgb(0, 0, 192,0.4)', 'rgb(0, 0, 192,0.6)', 'rgb(0, 0, 192,0.8)', 'rgb(0, 0, 192,1)'],
    //     dataLabels: {
    //         enabled: true,
    //         formatter: function (val) {
    //             return val > 0 ? (val > 1000 ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : val) : '-';
    //         },
    //         style: {
    //             colors: ['#000000'],
    //             fontSize: getFontSize(),
    //         },
    //     },
    // };

    // const options_percentage2 = {
    //     chart: {
    //         type: 'heatmap',
    //         dropShadow: {
    //             enabled: false,
    //         },
    //         toolbar: {
    //             show: false,
    //         },
    //     },
    //     title: {
    //         text: 'Percentage Heat Map ครั้งที่ 2',
    //         align: 'center',
    //         style: {
    //             fontSize: '12px',

    //         },
    //     },
    //     xaxis: {
    //         categories: Heatmap2[0]?.series.map(s => s.category),
    //         labels: {
    //             style: {
    //                 fontSize: getFontSize(),
    //             },
    //         },
    //     },
    //     yaxis: {
    //         title: {
    //             text: 'Station',
    //         },

    //         categories: Object.keys(percentageData),
    //         labels: {
    //             style: {
    //                 fontSize: getFontSize(),
    //             },
    //         },
    //     },
    //     colors: ['rgb(0, 0, 192,0.2)', 'rgb(0, 0, 192,0.4)', 'rgb(0, 0, 192,0.6)', 'rgb(0, 0, 192,0.8)', 'rgb(0, 0, 192,1)'],
    //     dataLabels: {
    //         enabled: true,
    //         formatter: function (val) {
    //             return val > 0 ? `${val.toFixed(1)}%` : '-';
    //         },
    //         style: {
    //             colors: ['#000000'],
    //             fontSize: getFontSize(),
    //         },
    //     },
    //     series: Object.keys(percentageData).map(exercise => ({
    //         name: exercise,
    //         data: Object.keys(percentageData[exercise]).map(range => parseFloat(percentageData[exercise][range])),
    //     })),
    // };

    const data_Report1 = {
        labels: ['เข้ารับการทดสอบ', 'ไม่เข้ารับการทดสอบ'],
        datasets: [
            {
                label: 'ร้อยละ ',
                data: [percentageTested1, percentageNotTested1],
                backgroundColor: [
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(255, 99, 132, 0.6)',
                ],
                hoverBackgroundColor: [
                    'rgba(54, 162, 235, 0.8)',
                    'rgba(255, 99, 132, 0.8)',
                ],
                borderWidth: 1,
            },
        ],
    };
    const options_Report1 = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    usePointStyle: true,

                }
            },
            title: {
                display: true,
                text: `ครั้งที่ 1: จากทั้งหมด ${num_unit1} หน่วย`,
            }, tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const datasetIndex = tooltipItem.datasetIndex;
                        const dataIndex = tooltipItem.dataIndex;
                        const value = tooltipItem.raw;


                        if (dataIndex === 0) {
                            return ` เข้าทดสอบ: ${numTested1} คน (ร้อยละ ${percentageTested1.toFixed(2)}%)`;
                        } else {
                            return ` ไม่เข้าทดสอบ: ${numNotTested1} คน (ร้อยละ ${percentageNotTested1.toFixed(2)}%)`;
                        }
                    }
                }
            }
        },
    };

    const data_Result_Report1 = {
        labels: [''],
        datasets: [
            {
                label: 'ผ่าน',
                data: [numPass1],
                backgroundColor: 'rgba(53, 162, 235, 0.6)',
            },
            {
                label: 'ไม่ผ่าน',
                data: [numNoPass1],
                backgroundColor: 'rgba(255, 99, 132, 0.6)',
            },

        ],
    };
    const options_Result_Report1 = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    usePointStyle: true,

                }
            },
            title: {
                display: true,
                text: `ร้อยละการทดสอบ ผ่าน/ไม่ผ่าน ครั้งที่ 1 (${numTested1} คน)`,
            }, tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const datasetIndex = tooltipItem.datasetIndex;
                        const value = tooltipItem.raw;

                        if (datasetIndex === 0) {
                            return `ผ่าน: ${num_pass_all_score1} คน (ร้อยละ ${numPass1.toFixed(2)}%)`;
                        } else if (datasetIndex === 1) {
                            return `ไม่ผ่าน: ${num_no_pass1} คน (ร้อยละ ${numNoPass1.toFixed(2)}%)`;
                        }
                    }
                }
            }
        },
        scales: {
            x: {
                beginAtZero: true,
                reverse: true,
                max: 100,
            },
        }

    };

    const data_Report2 = {
        labels: ['เข้ารับการทดสอบ', 'ไม่เข้ารับการทดสอบ'],
        datasets: [
            {
                label: 'ร้อยละ ',
                data: [percentageTested2, percentageNotTested2],
                backgroundColor: [
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(255, 99, 132, 0.6)',
                ],
                hoverBackgroundColor: [
                    'rgba(54, 162, 235, 0.8)',
                    'rgba(255, 99, 132, 0.8)',
                ],
                borderWidth: 1,
            },
        ],
    };
    const options_Report2 = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    usePointStyle: true,

                }
            },
            title: {
                display: true,
                text: `ครั้งที่ 2: จากทั้งหมด ${num_unit2} หน่วย`,
            }, tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const datasetIndex = tooltipItem.datasetIndex;
                        const dataIndex = tooltipItem.dataIndex;
                        const value = tooltipItem.raw;


                        if (dataIndex === 0) {
                            return ` เข้าทดสอบ: ${numTested2} คน (ร้อยละ ${percentageTested2.toFixed(2)}%)`;
                        } else {
                            return ` ไม่เข้าทดสอบ: ${numNotTested2} คน (ร้อยละ ${percentageNotTested2.toFixed(2)}%)`;
                        }
                    }
                }
            }
        },
    };

    const data_Result_Report2 = {
        labels: [''],
        datasets: [
            {
                label: 'ผ่าน',
                data: [numPass2],
                backgroundColor: 'rgba(53, 162, 235, 0.6)',
            },
            {
                label: 'ไม่ผ่าน',
                data: [numNoPass2],
                backgroundColor: 'rgba(255, 99, 132, 0.6)',
            },

        ],
    };
    const options_Result_Report2 = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    usePointStyle: true,

                }
            },
            title: {
                display: true,
                text: `ร้อยละการทดสอบ ผ่าน/ไม่ผ่าน ครั้งที่ 2 (${numTested2} คน)`,
            }, tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const datasetIndex = tooltipItem.datasetIndex;
                        const value = tooltipItem.raw;

                        if (datasetIndex === 0) {
                            return `ผ่าน: ${num_pass_all_score2} คน (ร้อยละ ${numPass2.toFixed(2)}%)`;
                        } else if (datasetIndex === 1) {
                            return `ไม่ผ่าน: ${num_no_pass2} คน (ร้อยละ ${numNoPass2.toFixed(2)}%)`;
                        }
                    }
                }
            }
        },
        scales: {
            x: {
                beginAtZero: true,
                reverse: true,
                max: 100,
            },
        }

    };

    const data_pass_all_station = {
        labels: ['ผู้ทำการภาคพื้น', 'ผู้ทำการในอากาศ'],
        datasets: [
            {
                label: 'ครั้งที่ 1  ',
                type: 'bar',
                data: [round1Ground.toFixed(2), round1Air.toFixed(2)],
                backgroundColor: 'rgba(53, 162, 235)',
                borderWidth: 1,
            },
            {
                label: 'ครั้งที่ 2',
                type: 'bar',
                data: [round2Ground.toFixed(2), round2Air.toFixed(2)],
                backgroundColor: 'rgba(75, 192, 192)',
                borderWidth: 1,
            },
        ],
    };
    const options_pass_all_station = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const label = context.dataset.label || '';
                        const value = context.raw;
                        return `${label}: ร้อยละ ${value}%`;
                    },
                },
            },
            legend: {
                position: 'top',
            },
        },
        scales: {
            x: {
                type: 'category',
                ticks: {
                    autoSkip: false,
                },
            },
            y: {
                type: 'linear',
                min: 80,
                max: 100,
                ticks: {
                    stepSize: 5,
                },
            },
        }
    };
    // console.log("chartReady",chartReady);


    return (

        <div className="col-12 m-0 p-0 pt-2">
            <div className="card ">
                {/* <div className="card-body col-12 pt-3 ">
                    {loading ? (
                        <LoadingTable />
                    ) : chartReady ? (
                        <div>
                            <h5 className="card-title fw-bold text-start">รายงานผลการทดสอบ<span>|   ณ {thai_date(DateTime)}</span></h5>
                            <div className="d-flex row" >
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-0">

                                    <div className="card-body ">

                                        <div className="align-items-center d-flex justify-content-center " style={{ height: "300px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            <Pie options={options_Report1} data={data_Report1} />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-0">

                                    <div className="card-body">

                                        <div className="align-items-center d-flex justify-content-center" style={{ height: "300px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            <Bar options={options_Result_Report1} data={data_Result_Report1} style={{ height: "350px" }} />

                                        </div>
                                    </div>

                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-0">

                                    <div className="card-body ">

                                        <div className="align-items-center d-flex justify-content-center " style={{ height: "300px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            <Pie options={options_Report2} data={data_Report2} />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-0">

                                    <div className="card-body">

                                        <div className="align-items-center d-flex justify-content-center" style={{ height: "300px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            <Bar options={options_Result_Report2} data={data_Result_Report2} style={{ height: "350px" }} />

                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>


                    )

                        : null}
                </div>
                <div className="card-body col-12 pt-3 ">
                    {loading ? (
                        <LoadingTable />
                    ) : chartReady ? (
                        <div>

                            <div className="card-body">
                                <h5 className="card-title fw-bold text-start">กำลังพลที่ทดสอบผ่าน (เฉพาะผู้ที่ทดสอบครบทั้ง 3 ประเภท)<span>|   ณ {thai_date(DateTime)}</span></h5>

                                <div className="align-items-center d-flex justify-content-center" style={{ height: "300px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>
                                    <Bar options={options_pass_all_station} data={data_pass_all_station} />
                                </div>

                            </div>

                        </div>


                    )

                        : null}
                </div> */}

                <div className="card-body col-12 pt-3 ">
                    {loading ? (
                        <LoadingTable />
                    ) : 
                    chartReady ? (
                        <div >
                            <div className="card-body">
                                <h5 className="card-title fw-bold text-start">Heatmap 3 ประเภท<span>|   ณ {thai_date(DateTime,"shortdate")}</span></h5>
                            </div>
                            <div className="d-flex row" >
                                {/* <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body pt-1" style={{ backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                        <div id="chart" style={{ maxWidth: '100%', height: '400px', margin: '35px auto' }}>
                                            <ApexCharts options={options_score1} series={score1} type="heatmap" width="100%" height="100%" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body pt-1" style={{ backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                        <div id="chart" style={{ maxWidth: '100%', height: '400px', margin: '35px auto' }}>
                                            <ApexCharts options={options_percentage1} series={percentage1} type="heatmap" width="100%" height="100%" />
                                        </div>
                                    </div>

                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1" >

                                    <div className="card-body pt-1" style={{ backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                        <div id="chart" style={{ maxWidth: '100%', height: '400px', margin: '35px auto' }}>
                                            <ApexCharts options={options_score2} series={score2} type="heatmap" width="100%" height="100%" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body pt-1" style={{ backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                        <div id="chart" style={{ maxWidth: '100%', height: '400px', margin: '35px auto' }}>
                                            <ApexCharts options={options_percentage2} series={percentage2} type="heatmap" width="100%" height="100%" />
                                        </div>
                                    </div>

                                </div> */}

                                {charts.map((chart, index) => (
                                    <div key={index} className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">
                                        <div className="card-body pt-1" style={{ backgroundColor: "rgba(206, 222, 239, 0.2)" }}>
                                            <div id="chart" style={{ maxWidth: '100%', height: '400px', margin: '35px auto' }}>
                                                <ApexCharts options={getOptions(chart.title, chart.data, chart.formatter, chart.categories)} series={chart.series} type="heatmap" width="100%" height="100%" />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>


                    )

                        : null
                        }
                </div>

            </div>
        </div >





    );
};

export default ReportChartComponent;
